<template>
    <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
            <v-card-title class="headline flex-column pa-2">
                <div class="d-flex fill-width">
                    <div class="flex-grow-1">{{$translate('Do you always want to call everyone on the team to the matches?')}}</div>
                    <v-btn icon @click="emitAnswer('no')" class="float-right"><v-icon>mdi-close</v-icon></v-btn>
                </div>
            </v-card-title>

            <v-card-text>{{$translate('An email summon will then be sent within 3 days before the match to everyone on the team.')}}</v-card-text>

            <div class="flex-column pa-4">
                <v-btn color="success" block @click="emitAnswer('yes')" class="mb-2"><v-icon left>mdi-check</v-icon>{{$translate('Yes please, always summon everyone automatically')}}</v-btn>
                <v-btn color="error" block @click="emitAnswer('no')" class="mb-2"><v-icon left>mdi-close</v-icon>{{$translate('No thanks')}}</v-btn>
                <v-btn color="error" block @click="emitAnswer('never')"><v-icon left>mdi-information-outline</v-icon>{{$translate('No thanks, do not ask me again')}}</v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'zoezi-teamsport-invite-all-dialog',

    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        dialog: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    },
    methods: {
        emitAnswer(answer) {
            this.$emit('answer', answer);
        }
    }
};
</script>
